import api from './api';

export interface ReprocessingRecord {
  id: number;
  trello_card_id: string;
  trello_card_name: string;
  trello_card_url?: string;
  trello_card_desc?: string;
  source_list_name?: string;
  source_board_name?: string;
  batch_number: string;
  rejection_cause?: 'color' | 'layout';
  assigned_section?: 'digital' | 'rotary';
  collected_yard?: 'yes' | 'no';
  cut_location?: 'start' | 'middle' | 'end';
  color_response?: 'approved' | 'rejected';
  color_response_remarks?: string;
  reprocessing_description?: string;
  reprocessing_steps?: string[];
  reprocessing_completed_at?: string;
  handed_to_finishing_at?: string;
  phase: 'initial_review' | 'second_verification' | 'color_team' | 'reprocessing' | 'finishing_handover' | 'completed';
  status: 'active' | 'completed' | 'cancelled';
  workflow_history?: Array<{ phase: string; action: string; by_id?: number; at: string }>;
  created_at?: string;
  updated_at?: string;
  created_by_name?: string;
  updated_by_name?: string;
}

export const reprocessingManagementService = {
  searchPrintingOut: async (batchNumber: string) => {
    const response = await api.get('/reprocessing-management/search-printing-out', { params: { batch_number: batchNumber } });
    return response.data;
  },
  getAll: async (params?: { phase?: string; status?: string; search?: string }) => {
    const response = await api.get('/reprocessing-management', { params });
    return response.data;
  },
  getById: async (id: number) => {
    const response = await api.get(`/reprocessing-management/${id}`);
    return response.data;
  },
  create: async (data: Record<string, unknown>) => {
    const response = await api.post('/reprocessing-management', data);
    return response.data;
  },
  proceed: async (id: number, data: Record<string, unknown>) => {
    const response = await api.post(`/reprocessing-management/${id}/proceed`, data);
    return response.data;
  },
  update: async (id: number, data: Record<string, unknown>) => {
    const response = await api.patch(`/reprocessing-management/${id}`, data);
    return response.data;
  },
  delete: async (id: number) => {
    const response = await api.delete(`/reprocessing-management/${id}`);
    return response.data;
  },
};

export default reprocessingManagementService;
